<template>
  <main class="user-detail-popup" v-if="skinList">
   <div class="user-wrapper-outer w100w">
     <div class="wrapper-title">
       <div class="subWrap fx vt-c gap-10">
         <span>스킨설정</span>
       </div>
     </div>
     <div class="wrapper-contents s-content-wrap">
      <table class="mainTable">
        <colgroup>
          <col style="width: 25%">
          <col style="width: 25%">
          <col style="width: 25%">
          <col style="width: 25%">
        </colgroup>
        <thead>
          <tr>
            <th>게임사(벤더)명</th>
            <th>최소베팅액</th>
            <th>최대베팅액</th>
            <th>스킨타입</th>
            <th>저장</th>
          </tr>
        </thead>
        <tbody>
          <template v-if="skinList.length > 0">
            <tr v-for="item in skinList" :key="item.vendorIdx">
              <td>{{ item.vendorName }}</td>
              <td>{{ thousand(item.minBetAmt) }}</td>
              <td>{{ thousand(item.maxBetAmt) }}</td>
              <td>
                <select v-model="item.nexusSkinType" @change="changeSkin(item)">
                  <template v-for="skin in item.skinList">
                    <option :value="skin.nexusSkinType">{{skin.nexusSkinType}}</option>
                  </template>
                </select>
              </td>
              <td>
                <button type="button" @click="setSkin(item)">저장</button>
              </td>
            </tr>
          </template>
          <template v-else>
            <tr><td colspan="5">내역이 없습니다.</td></tr>
          </template>
        </tbody>
      </table>
     </div>
   </div>
  </main>
</template>

<script>
import lodash from "lodash"
import { getCode } from "@/api/utils"
import subTitle from "@/components/main/PageSubTitle"
import { mapState } from "vuex"
import {getApiSkinList, setApiSkin} from "@/api/company";
import {sk} from "date-fns/locale";
import skin from "@/views/member/company/pages/game/skin.vue";
import {thousand} from "../../../../../libs/utils";

export default {
  name: "skin",
  components: {
    subTitle
  },
  data() {
    return {
      reqData: {
        siteId: ''
      },
      skinList: null
    }
  },
  watch: {
  },
  methods: {
    thousand,
    changeSkin (item) {
      item.skinList.forEach(skin => {
        if (skin.nexusSkinType === item.nexusSkinType) {
          item.minBetAmt = skin.minBetAmt
          item.maxBetAmt = skin.maxBetAmt
        }
      })
    },
    setSkin (item) {
      const params = {
        siteId: this.reqData.siteId,
        siteIdx: item.siteIdx,
        vendorIdx: item.vendorIdx,
        nexusSkinType: item.nexusSkinType
      }
      if (confirm(`${item.vendorName}의 스킨타입을 ${item.nexusSkinType}로 저장하시겠습니까?`)) {
        setApiSkin(params).then(res => {
          if (res.resultCode === '0') {
            alert('정상적으로 저장되었습니다.')
          } else {
            alert(res.resultMessage)
          }
        })
      }
    },
    getSkinList () {
      const params = {
        ...this.reqData
      }

      getApiSkinList(params).then(res => {
        if (res.resultCode === '0') {
          this.skinList = res.data.skinInfo
        } else {
          alert(res.resultMessage)
        }
      })
    }
  },
  computed: {
    ...mapState([
      'siteData'
    ]),
  },
  async created() {
    const siteId = this.$route.query.id
    if(siteId) {
      this.reqData.siteId = siteId
    }

    await this.getSkinList()
  }
};
</script>

<style scoped>
.mainTable button {
    padding: 5px 8px;
    background-color: #fff;
    border: 1px solid #126ae2;
    border-radius: 5px;
    box-sizing: border-box;
    color: #126ae2;
    font-size: 13px;
    font-weight: 500;
    cursor: pointer;
}
.w100w {width: 100% !important;}
.w25w {width: 25% !important;}
.fx {display: flex !important;justify-content: initial;}

.user-detail-popup {
  display: flex;
  justify-content: space-between;
  padding: 10px;
  width: 1435px;
  gap: 15px;
  margin: 0;
  box-sizing: border-box;
}
.user-detail-popup select {
  font-size: 1em;
}
.wrapper-title .btn-save {
  width: 42px;
  height: 21px;
  border-radius: 5px;
  font-size: 10px;
  font-weight: 500;
  background-color: #126ae2;
}
.wrapper-title .btn-save:hover {
  color: #126ae2;
  background: #fff;
}
input[type="text"],
input[type="number"],
input[type="password"] {
  font-weight: 500;
  border: 1px solid #c5c5c5;
  height: 21px;
  padding: 0 6px;
  box-sizing: border-box;
  border-radius: 3px;
}
select {
  border: 1px solid #c5c5c5;
}
.mainTable {
  font-size: 12px !important;
}
.mainTable th {
  height: 35px;
  /* background: var(--main); */
  background: #18698b;
  color: #fff;
  font-weight: 700;
  vertical-align: middle;
}
.wrapper-title {
  margin-bottom: 0;
}
.s-content-wrap {
  overflow: visible;
  height: fit-content;
  max-height: unset;
  padding: 15px 0;
}
</style>
